var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.7236 11.2764C72.9438 18.4965 77 28.2892 77 38.5C77 48.7108 72.9438 58.5034 65.7236 65.7236L60.2789 60.2789C66.055 54.5028 69.3 46.6687 69.3 38.5C69.3 30.3313 66.055 22.4972 60.2789 16.7211L65.7236 11.2764Z",
    fill: "#67E646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2764 65.7236C7.70133 62.1486 4.86544 57.9043 2.93064 53.2333C0.995829 48.5623 -1.64742e-06 43.5559 0 38.5C1.64742e-06 33.4441 0.995836 28.4377 2.93065 23.7667C4.86545 19.0956 7.70135 14.8514 11.2764 11.2764L16.7211 16.7211C13.8611 19.5811 11.5924 22.9765 10.0445 26.7133C8.49667 30.4502 7.7 34.4553 7.7 38.5C7.7 42.5447 8.49666 46.5498 10.0445 50.2866C11.5924 54.0235 13.8611 57.4188 16.7211 60.2789L11.2764 65.7236Z",
    fill: "#67E646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.0e528c5cf8abb017d80d711a5e08ff5d.svg";
export { ForwardRef as ReactComponent };